
<header class="modal-header confirmar-correo-bg">
  <div class="modal-title text-center text-white h3 w-100 p-5">
    {{titulo}}
  </div>
</header>
<section class="modal-body text-center pl-5 pr-5 pb-5">
  <div [innerHTML]="mensaje"></div>

</section>
<footer class="modal-footer">
  <button class="btn btn-success" (click)="confirm()">Aceptar</button>
  <button class="btn btn-primary" (click)="abortar()">Abandonar</button>
  <button class="btn btn-outline-secondary" (click)="cancel()">Cancelaci&oacute;n</button>
</footer>
